<div class="casePnlBox">
      <div class="case-header">
        <h3 ><img src="../../../../assets/cocoonImages/back-up-icon.svg" alt="Case Backup">
           {{this.data.name}}-{{this.data.caseType}}
        </h3>
        <a (click)="openCaseView()" class="view-details" pTooltip="View Case" style="cursor: pointer;">
          <img src="../../../../assets/cocoonImages/view-icon.svg" alt="View Icon">
        </a>
      </div>
      <div class="case-content">
        <ul class="listScroll"  >
          <li class="fade-in" #fadeElements *ngFor="let item of displayList">
            {{ item.label }}<span>  {{ isDate(item.value) ? (item.value | date:"MMM dd, yyyy") : item.value }}</span>
          </li>
        </ul>
      </div>
    </div> 